import './core/i18n'

import { Helmet, HelmetProvider } from 'react-helmet-async'

import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'
import { RecoilRoot } from 'recoil'
import { UserTokenInformation } from 'core/api/types'
import preLoader from 'core/loader'
import { SauceWebLib } from 'core/util/module/SauceWebLib'
import { ConfigWebLib } from 'core/util/module/ConfigWebLib'
import { TokenWebLib } from 'core/util/module/TokenWebLib'

export interface RootParams {
  id?: string
  partnerId?: string
  accessToken?: string
  broadcast?: boolean
  schedule?: boolean
  scheduleType?: 'image' | 'feed' | 'list'
  curation?: boolean
  autoPlay?: boolean
  curationDetail?: boolean
  searchBar?: boolean
  sampleTitle?: boolean
  bridge?: boolean
  router?: boolean
  broadcastOpenLink?: string
  broadcastTable?: boolean
  contentBanner?: boolean
  textBanner?: boolean
  curationId?: string
  topBanner?: boolean
  sauceClip?: boolean
  configInstance?: ConfigWebLib
  tokenInstance?: TokenWebLib
}

window.SauceWebLib = function ({
  id = 'sauce_collect',
  partnerId = 'undefined',
  accessToken = 'undefined',
  broadcast = true,
  curation = true,
  curationDetail = true,
  schedule = true,
  scheduleType = 'image',
  autoPlay = false,
  searchBar = true,
  sampleTitle = false,
  bridge = false,
  router = true,
  broadcastOpenLink = '',
  broadcastTable = false,
  contentBanner = false,
  textBanner = false,
  curationId = undefined,
  sauceClip = true,
  topBanner = true,
}: RootParams) {
  preLoader(partnerId).then(({ config, theme, themeB }) => {
    // eslint-disable-next-line react/no-render-return-value
    return ReactDOM.render(
      <React.StrictMode>
        <HelmetProvider>
          <Helmet />
          <RecoilRoot>
            <App
              bridge={bridge}
              partnerId={partnerId}
              accessToken={accessToken}
              broadcast={broadcast}
              curation={curation}
              curationDetail={curationDetail}
              schedule={schedule}
              scheduleType={scheduleType}
              autoPlay={autoPlay}
              router={router}
              searchBar={searchBar}
              sampleTitle={sampleTitle}
              broadcastOpenLink={broadcastOpenLink}
              theme={theme}
              themeB={themeB}
              config={config}
              broadcastTable={broadcastTable}
              contentBanner={contentBanner}
              textBanner={textBanner}
              curationId={curationId}
              sauceClip={sauceClip}
              topBanner={topBanner}
            />
          </RecoilRoot>
        </HelmetProvider>
      </React.StrictMode>,
      document.getElementById(id),
    )
  })
}

window.SauceWebLib.setInit = (arg: RootParams) => {
  const collectLib = new SauceWebLib(arg)
  window.SauceWebLib.load = async (id?: string) => await collectLib.load(id)
  window.SauceWebLib.setMemberObject = async (arg: UserTokenInformation) => {
    await collectLib.setMemberObject(arg)
  }
  window.SauceWebLib.setLogout = () => {
    collectLib.setLogout()
  }
  window.SauceWebLib.loadCuration = ({
    curationId,
    elementId,
  }: {
    curationId: string
    elementId?: string
  }) => {
    collectLib.loadCuration({
      curationId,
      elementId,
    })
  }
  window.SauceWebLib.loadTopBanner = ({ elementId }: { elementId?: string }) => {
    collectLib.loadTopBanner(elementId)
  }

  window.SauceWebLib.loadCalendar = ({ elementId }: { elementId?: string }) => {
    collectLib.loadCalendar(elementId)
  }

  window.SauceWebLib.loadBroadcast = ({
    displayType,
    elementId,
    title,
  }: {
    displayType?: 'horizontal' | 'vertical'
    elementId?: string
    title?: string
  }) => {
    collectLib.loadBroadcast({ displayType, elementId, title })
  }

  window.SauceWebLib.loadSchedule = async ({
    scheduleType,
    elementId,
  }: {
    scheduleType?: 'image' | 'feed' | 'list'
    elementId?: string
  }) => {
    collectLib.loadSchedule({
      scheduleType,
      elementId,
    })
  }
  window.SauceWebLib.setMemberToken = async (token: string) =>
    await collectLib.setMemberToken(token)
}
